export { FavoriteButton, type IFavoriteButtonProps } from './favorite-button';
